import {inject} from '@angular/core';
import {Route} from '@angular/router';
import {Observable} from 'rxjs';
import {BuildingServices, FeatureFlagService} from '@brunata-angular/util';
import {unsavedChangesGuard} from '@brunata-angular/ui';
import {QuickExportsComponent} from './quick-exports/quick-exports.component';
import {CustomizedExportsComponent} from './customized-exports/customized-exports.component';
import {SavedExportsComponent} from './saved-exports/saved-exports.component';
import {SftpConnectionsComponent} from './sftp-connections/sftp-connections.component';
import {buildingServiceGuard} from './building-service.guard';

const CUSTOMIZED_EXPORTS_FEATURE_FLAG = 'online-customized-exports';
const SFTP_CONNECTIONS_FEATURE_FLAG = 'online-sftp-connections';

export const exportRoutes: Route[] = [
    {
        path: 'quick-exports',
        component: QuickExportsComponent,
        canDeactivate: [unsavedChangesGuard],
        canMatch: [buildingServiceGuard],
        data: {
            key: 'quickexports_export_tab_quick_exports',
            titleKey: 'quickexports_export_page_title',
            module: 'export',
            requireBuildingService: BuildingServices.ASE_QUICK_EXPORTS,
        },
    },
    {
        // No canDeactivate: the draft persists in local storage on every change, so leaving the
        // wizard loses nothing.
        path: 'customized-exports',
        component: CustomizedExportsComponent,
        canMatch: [
            buildingServiceGuard,
            (): Observable<boolean> =>
                inject(FeatureFlagService).isFeatureFlagEnabled$(CUSTOMIZED_EXPORTS_FEATURE_FLAG),
        ],
        data: {
            key: 'customizedexports_export_tab_customized_exports',
            titleKey: 'customizedexports_export_page_title',
            module: 'export',
            featureFlag: CUSTOMIZED_EXPORTS_FEATURE_FLAG,
            requireBuildingService: BuildingServices.ASE_CUSTOMIZED_EXPORTS,
        },
    },
    {
        path: 'saved-exports',
        component: SavedExportsComponent,
        canMatch: [buildingServiceGuard],
        data: {
            key: 'quickexports_export_tab_saved_exports',
            titleKey: 'savedexport_export_page_title',
            module: 'export',
            requireBuildingService: BuildingServices.ASE_SAVED_EXPORTS,
        },
    },
    {
        path: 'connections',
        component: SftpConnectionsComponent,
        canMatch: [
            buildingServiceGuard,
            (): Observable<boolean> =>
                inject(FeatureFlagService).isFeatureFlagEnabled$(SFTP_CONNECTIONS_FEATURE_FLAG),
        ],
        data: {
            key: 'sftpconnection_export_tab_connections',
            titleKey: 'sftpconnection_export_page_title',
            module: 'export',
            featureFlag: SFTP_CONNECTIONS_FEATURE_FLAG,
            requireBuildingService: BuildingServices.ASE_ADVANCED_DELIVERY,
        },
    },
];

// ExportComponent lands the user on their first visible tab, so there is no empty-path redirect
// to keep in step with this list.
export const ACROSS_SYSTEMS_EXPORT_SERVICES = exportRoutes
    .map((route): unknown => route.data?.['requireBuildingService'])
    .filter((service): service is BuildingServices => typeof service === 'number');
